module.exports = __webpack_public_path__ + "media/images/icons/programme_completed_icon-7f316911bc0fb751410993174a70e73e.svg";